import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { red, yellow } from "@mui/material/colors";
import { useEffect, useState } from "react";
import partialDelete from "./PartialDelete";
import Create from "./Create";

function Outbox(props) {
  const { setMain } = props;

  const [messages, setMessages] = useState([]);

  const outboxMessages = messages.filter((msg) => {
    return msg.label === "outbox" && msg.deleted === false ? true : false;
  });

  useEffect(() => {
    getMessages();
  }, []);

  const handleResend = (text) => {
    setMain(<Create text={text} />);
  };

  const handleDelete = (id) => {
    const filteredMessages = messages.map((mesg) => {
      if (id === mesg.id) {
        mesg.deleted = true;
      }
      return mesg;
    });
    setMessages(filteredMessages);
    const params = {
      url: "http://127.0.0.1:8000/messenger/messages/",
      method: "PATCH",
      params: {
        id: id,
        type: "delete",
      },
    };
    const results = partialDelete(params);
  };

  async function getMessages() {
    const response = await fetch("http://127.0.0.1:8000/messenger/messages/", {
      mode: "cors",
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    const fetcher = response.body.getReader();
    let data = [];
    let receivedLength = 0;
    while (true) {
      const { value, done } = await fetcher.read();

      if (done) {
        break;
      }

      data.push(value);
      receivedLength += value.length;
    }
    let chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (let chunk of data) {
      chunksAll.set(chunk, position);
      position += chunk.length;
    }
    let result = new TextDecoder("utf-8").decode(chunksAll);

    let finalData = JSON.parse(result);
    setMessages(finalData);
  }

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Typography variant="h6">Outbox</Typography>
        <Divider variant="middle" />
        {outboxMessages.length > 0 ? (
          outboxMessages.map((message) => {
            return (
              <Card elevation={3} key={message.id} sx={{ mt: 1, mb: 1 }}>
                <CardHeader
                  sx={{ bgcolor: yellow[500] }}
                  avatar={<Avatar sx={{ bgcolor: red[700] }}>O</Avatar>}
                  title={message.date}
                />
                <CardContent>
                  <Typography>{message.message}</Typography>
                </CardContent>
                <CardActions
                  sx={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <Button onClick={() => handleResend(message.message)}>
                    Resend
                  </Button>
                  <Button
                    color="error"
                    onClick={() => handleDelete(message.id)}
                  >
                    Delete
                  </Button>
                </CardActions>
              </Card>
            );
          })
        ) : (
          <Box display={"flex"} justifyContent={"center"} mt={2}>
            <Typography>No Failed Messages</Typography>
          </Box>
        )}
      </Stack>
    </Zoom>
  );
}

export default Outbox;
